function AppContextService($q, AppSettings, AuthService, CommonService) {
    'ngInject';

    this.context = {
        players: {
            game: {
                my_team: {
                    // all: [],
                    // entryMain: [],
                    // entryBackup: [],
                    // gameIn: []
                },
                oppo_team: {
                    // all: [],
                    // entryMain: [],
                    // entryBackup: [],
                    // gameIn: []
                }
            },
            training: {
                my_team: {
                    // all: [],
                    // entryMain: [],
                    // entryBackup: [],
                    // gameIn: []
                }
            }
        }
    };

};

export default {
    name: 'AppContextService',
    fn: AppContextService
};
